<template>
  <div class="Certify">
    <div class="note fs22">
      为了保证后续比赛的顺利进行，请务必于11月15日前进行实名认证，否则将<span>取消晋级资格</span>。
    </div>
    <div>
      <my_input v-for="f in forms" :key="f.label" :type="f.type" :placeholder="f.placeholder" v-model="fm[f.label]" :error="error[f.label]"></my_input>
    </div>
    <div class="tips fs18">
      （注：填写学校或者机构名称，或者不填(个人)
    </div>
    <div class="button" @click="submit" :disable="!checkCertify()">
      提交
    </div>
  </div>
</template>

<script>
 import MyInput from '@/components/Input.vue';
 export default {
   name: 'Certify',
   props: {
   },
   components:{
     my_input: MyInput
   },
   computed: {
     
     forms () {
       return this.$store.state.account.certification.forms
     },
   },
   methods: {
     resetError() {
       this.error = {
         name: '',
         idcard: '',
         organization: '',
       }
     },
     checkCertify() {
       if(this.fm.name && this.fm.idcard)
         {
           if(/^\d{17}\w$/.test(this.fm.idcard))
             {
               this.error.idcard = ''
               return true
             }
           else{
             this.error.idcard='身份证格式有误'
           }
         }
       return false
     },
     
     submit() {
       this.state='认证中'
       let data = new FormData();
       data.set('name', this.fm.name)
       data.set('idcard', this.fm.idcard)
       data.set('organization', this.fm.organization)
       this.$http.post('/api/user/auth_idcard', data)
           .then(res => {
             console.log(res)
             this.state='认证成功'
             let that = this
             this.$store.commit('SET_USER', res.data)
           })
           .catch(e => {
             let error = e.response.data.errors
             this.reseting = true;
             for(let e in error)
               {
                 this.fm[e] = ''
                 this.error[e] = error[e]
               }
             this.$nextTick(()=>{
               this.reseting = false
             })
           })
     }
   },
   watch: {
     fm: {
       handler () {
         this.state = '认证'
         if(!this.reseting)
           this.resetError()
       },
       deep: true
     }
   },
   data(){
     return {
       fm: {
         name: '',
         idcard: '',
         organization: '',
       },
       error: {
         name: '',
         idcard: '',
         organization: '',
       },
       state: '认证',
       reseting: false
     }
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .note{
   color: #5a5a5a;
   font-weight: 400;
 }
 .note span{
   color: red;
 }

 input[type="text"]{
   width:15vw;
   line-height: 1.1vw !important;;
   font-size: 1.04vw;
   height: 2vw;
   border: 1px solid #d8d8d8;
   margin-top: 1vw;
   box-sizing: border-box;
   padding-left: 0.8em;
 }
 .button{
   width: 5vw;
   height: 2vw;
   margin-top: 1vw;
   display:inline-block;
   display:flex;
   align-items:center;
   justify-content:center;
   color: white;
   cursor: pointer;
   background: linear-gradient(to right, #4ca1fb, #405aee);
 }
 .flex{
   display:flex;
 }
 .tips{
   color: #8A8A8A;
   margin-top: 0.7vw;
 }
</style>


